export type DashboardScope = 'account' | 'activity';

export interface DashboardSection {
  id: string;
  label: string;
  /** Team layout only: which role-gated scope this section belongs to. */
  scope?: DashboardScope;
}

export const SCOPE_LABELS: Record<DashboardScope, string> = {
  account: 'Account',
  activity: 'My activity',
};

// Team layout (credit-team / smb-team). Two mutually-exclusive scopes:
// - Account (Owner/Admin only): Account Overview, Network, Team Activity.
// - My activity (everyone): Upcoming Calls, Projects, Consultations, Experts.
// Member/Viewer see only My activity (the Account sections are filtered out in
// DashboardBody before this list reaches the side nav).
export const TEAM_SECTIONS: DashboardSection[] = [
  { id: 'account-overview', label: 'Account Overview', scope: 'account' },
  { id: 'expert-network', label: 'Network', scope: 'account' },
  { id: 'team-activity', label: 'Team Activity', scope: 'account' },
  { id: 'upcoming-calls', label: 'Upcoming Calls', scope: 'activity' },
  { id: 'my-projects', label: 'Projects', scope: 'activity' },
  { id: 'recent-consultations', label: 'Consultations', scope: 'activity' },
  { id: 'my-experts', label: 'Experts', scope: 'activity' },
];

export const EXPERT_SECTIONS: DashboardSection[] = [
  { id: 'my-activity', label: 'My Activity' },
  { id: 'upcoming-calls', label: 'Upcoming Calls' },
  { id: 'my-engagements', label: 'My Engagements' },
];

export const CLIENT_SECTIONS: DashboardSection[] = [
  { id: 'upcoming-calls', label: 'Upcoming Calls' },
  { id: 'recent-consultations', label: 'Recent Consultations' },
];
